import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

class CreditorForm extends Form {
  static contextType = PopUpContext;

  state = {
    drp: {
      deptTypes: [],
    },
    data: {
      name: "",
      name_en: "",
      phone: "",
      photo: "",
      email: "",
      debt_type_id: "",
      remark: "",
    },
    errors: {},
  };

  componentDidMount = async () => {
    const { drp, data } = this.state;

    const {
      popUp: { edit },
    } = this.context;

    if (edit) {
      data.name = edit.name;
      data.name_en = edit.name_en;
      data.phone = edit.phone;
      data.photo = edit.photo;
      data.email = edit.email;
      data.debt_type_id = edit.debt_type_id;
      data.remark = edit.remark;
    }

    await db
      .getAll(`dropdowns/debtTypes`)
      .then(({ data: { data } }) => (drp["deptTypes"] = data));

    this.setState({ drp });
  };

  schema = {
    name: Joi.string().max(128).required(),
    name_en: Joi.string().max(128).required(),
    phone: Joi.string().max(14).required(),
    photo: Joi.string().max(256).allow(null).allow(""),
    email: Joi.string().max(128).required(),
    debt_type_id: Joi.number().required(),
    remark: Joi.string().max(1024),
  };

  doSubmit = async ({ target }) => {
    try {
      const { togglePopUp, popUp } = this.context;

      const __controls = this.cleanObject({
        ...this.state.data,
      });

      await db
        .form("creditors", target, __controls, popUp?.edit?.creditor_id)
        .then(() => {
          togglePopUp({ form: "toast" });
        })
        .catch((e) => {
          togglePopUp({
            form: "toast",
            message: e.toString(),
            type: "warning",
          });
        });
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        console.log(errors);

        this.setState({ errors });
      }
    }
  };

  render() {
    const { drp, data } = this.state;
    const { popUp } = this.context;

    return (
      <div className="form-container">
        <form className="form crud" onSubmit={this.handleSubmit}>
          <div className="head">
            <p>{popUp?.edit ? lbl.EditCreditor : lbl.SaveCreditor}</p>
          </div>
          <div className="form-inputs">
            {this.renderImg("photo", data.photo)}
            <div className="multi-input">
              {this.renderInput("name", "نام (فارسی)")}
              {this.renderInput("name_en", "نام (انگلیسی)")}
            </div>
            {this.renderInput("phone", "شماره تماس")}
            {this.renderInput("email", "ایمیل", "email")}
            {this.renderSelect("debt_type_id", "نوع بدهی", drp["deptTypes"])}
            {this.renderInput("remark", "ملاحظه", "textarea")}
          </div>
          <div className="form-buttons">
            {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
          </div>
        </form>
      </div>
    );
  }
}

export default CreditorForm;
